export const MiningResourcesPanel = ({ profile, recentResults, showHistory = true }) => {
  return (
    <div className={showHistory ? "grid xl:grid-cols-[0.95fr_1.05fr] gap-6" : "space-y-6"}>
      <section data-testid="mining-ore-inventory" className="border border-amber-900/30 bg-zinc-950/80 p-4 rounded-sm">
        <h2 className="font-cinzel text-base text-amber-300 uppercase tracking-wide">Raw Ore Inventory</h2>
        <div className="grid grid-cols-2 gap-3 mt-4">
          {Object.entries(profile?.raw_ore_fragments || {}).map(([rarity, amount]) => (
            <div key={rarity} data-testid={`mining-ore-${rarity}`} className="border border-zinc-800 bg-zinc-900/60 p-3 rounded-sm">
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">{rarity}</div>
              <div className="font-cinzel text-xl text-zinc-100 mt-2">{amount.toLocaleString()}</div>
            </div>
          ))}
        </div>
      </section>

      {showHistory && (
        <section data-testid="mining-history-panel" className="border border-amber-900/30 bg-zinc-950/80 p-4 rounded-sm">
          <h2 className="font-cinzel text-base text-amber-300 uppercase tracking-wide">Recent Expeditions</h2>
          <div className="mt-4 space-y-3">
            {recentResults?.length ? recentResults.map((run) => (
              <article key={run.id} data-testid={`mining-history-${run.id}`} className="border border-zinc-800 bg-zinc-900/60 p-3 rounded-sm">
                <div className="flex flex-wrap items-start justify-between gap-2">
                  <div>
                    <div className="font-cinzel text-zinc-100">{run.mine_name}</div>
                    <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-1">{new Date(run.claimed_at || run.completed_at).toLocaleString()}</div>
                  </div>
                  <div className="text-sm text-amber-300">{run.xp_gained} XP</div>
                </div>
                <div className="mt-2 text-sm text-zinc-300">
                  {Object.entries(run.raw_ore_rewards || {}).filter(([, amount]) => amount > 0).map(([rarity, amount]) => `${amount} ${rarity}`).join(" • ")}
                </div>
                {run.great_yield_triggered && <div className="mt-2 text-xs uppercase tracking-[0.2em] text-amber-400">Great yield</div>}
                {run.discovery && <div data-testid={`mining-history-discovery-${run.id}`} className="mt-2 text-xs uppercase tracking-[0.2em] text-amber-300">Discovery: {run.discovery.name}</div>}
              </article>
            )) : (
              <div data-testid="mining-history-empty" className="border border-dashed border-amber-900/30 bg-zinc-950/40 p-6 text-center text-zinc-500">
                No mining expeditions have been completed yet.
              </div>
            )}
          </div>
        </section>
      )}
    </div>
  );
};